"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/portal_common.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalOrderCartItemNotificationGoods = exports.PortalOrderCartItemNotificationGoodsUnaccessible = exports.PortalOrderCartItemNotificationGoodsPriceChanged = exports.PortalOrderCartItemNotificationGoodsOutOfSales = exports.PortalOrderCartItemNotificationGoodsShortOfStock = exports.PortalOrderCartItemNotificationGoodsOutOfStock = exports.PortalOrderCartNotification = exports.PortalOrderCartNotifications = exports.PortalOrderCartItem = exports.PortalOrderCart = exports.ShippingSetting = exports.PortalOrderCartItemGoods_VariantImage = exports.PortalOrderCartItemGoods = exports.PortalOrderGoodsImage = exports.PortalOrderLineItemGoodsSelfShipping = exports.PortalOrderLineItemGoodsDigital_File = exports.PortalOrderLineItemGoodsDigital = exports.PortalOrderLineItemBackNumber = exports.PortalOrderLineItemPlan = exports.PortalOrderLineItem = exports.PortalOrderShippingSelf = exports.PortalOrderShipping = exports.PortalOrder = exports.PortalOrderCartItemGoodsType = exports.PortalOrderFulfillmentStatus = exports.PortalOrderFinancialStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * https://github.com/balus-co-ltd/spwn/blob/38e7f14d735dfd5ba5a16acb6cd6c56876bb3c73/main/packages/bff/src/dto/fanClubOrderHistoryItem.ts#L30-L42
 *
 * @generated from enum spwn.order.v1.PortalOrderFinancialStatus
 */
var PortalOrderFinancialStatus;
(function (PortalOrderFinancialStatus) {
    /**
     * @generated from enum value: PORTAL_ORDER_FINANCIAL_STATUS_UNSPECIFIED = 0;
     */
    PortalOrderFinancialStatus[PortalOrderFinancialStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 未支払い
     *
     * @generated from enum value: PORTAL_ORDER_FINANCIAL_STATUS_PENDING = 1;
     */
    PortalOrderFinancialStatus[PortalOrderFinancialStatus["PENDING"] = 1] = "PENDING";
    /**
     * 支払い済み
     *
     * @generated from enum value: PORTAL_ORDER_FINANCIAL_STATUS_PAID = 2;
     */
    PortalOrderFinancialStatus[PortalOrderFinancialStatus["PAID"] = 2] = "PAID";
    /**
     * 返金済み
     *
     * @generated from enum value: PORTAL_ORDER_FINANCIAL_STATUS_REFUNDED = 3;
     */
    PortalOrderFinancialStatus[PortalOrderFinancialStatus["REFUNDED"] = 3] = "REFUNDED";
    /**
     * 支払い前に取り消し済み
     *
     * @generated from enum value: PORTAL_ORDER_FINANCIAL_STATUS_VOIDED = 4;
     */
    PortalOrderFinancialStatus[PortalOrderFinancialStatus["VOIDED"] = 4] = "VOIDED";
})(PortalOrderFinancialStatus = exports.PortalOrderFinancialStatus || (exports.PortalOrderFinancialStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalOrderFinancialStatus)
protobuf_1.proto3.util.setEnumType(PortalOrderFinancialStatus, "spwn.order.v1.PortalOrderFinancialStatus", [
    { no: 0, name: "PORTAL_ORDER_FINANCIAL_STATUS_UNSPECIFIED" },
    { no: 1, name: "PORTAL_ORDER_FINANCIAL_STATUS_PENDING" },
    { no: 2, name: "PORTAL_ORDER_FINANCIAL_STATUS_PAID" },
    { no: 3, name: "PORTAL_ORDER_FINANCIAL_STATUS_REFUNDED" },
    { no: 4, name: "PORTAL_ORDER_FINANCIAL_STATUS_VOIDED" },
]);
/**
 * @generated from enum spwn.order.v1.PortalOrderFulfillmentStatus
 */
var PortalOrderFulfillmentStatus;
(function (PortalOrderFulfillmentStatus) {
    /**
     * @generated from enum value: PORTAL_ORDER_FULFILLMENT_STATUS_UNSPECIFIED = 0;
     */
    PortalOrderFulfillmentStatus[PortalOrderFulfillmentStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 未発送
     *
     * @generated from enum value: PORTAL_ORDER_FULFILLMENT_STATUS_PENDING = 1;
     */
    PortalOrderFulfillmentStatus[PortalOrderFulfillmentStatus["PENDING"] = 1] = "PENDING";
    /**
     * 発送済み
     *
     * @generated from enum value: PORTAL_ORDER_FULFILLMENT_STATUS_SHIPPED = 2;
     */
    PortalOrderFulfillmentStatus[PortalOrderFulfillmentStatus["SHIPPED"] = 2] = "SHIPPED";
    /**
     * キャンセル済み
     *
     * @generated from enum value: PORTAL_ORDER_FULFILLMENT_STATUS_CANCELED = 3;
     */
    PortalOrderFulfillmentStatus[PortalOrderFulfillmentStatus["CANCELED"] = 3] = "CANCELED";
})(PortalOrderFulfillmentStatus = exports.PortalOrderFulfillmentStatus || (exports.PortalOrderFulfillmentStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalOrderFulfillmentStatus)
protobuf_1.proto3.util.setEnumType(PortalOrderFulfillmentStatus, "spwn.order.v1.PortalOrderFulfillmentStatus", [
    { no: 0, name: "PORTAL_ORDER_FULFILLMENT_STATUS_UNSPECIFIED" },
    { no: 1, name: "PORTAL_ORDER_FULFILLMENT_STATUS_PENDING" },
    { no: 2, name: "PORTAL_ORDER_FULFILLMENT_STATUS_SHIPPED" },
    { no: 3, name: "PORTAL_ORDER_FULFILLMENT_STATUS_CANCELED" },
]);
/**
 * @generated from enum spwn.order.v1.PortalOrderCartItemGoodsType
 */
var PortalOrderCartItemGoodsType;
(function (PortalOrderCartItemGoodsType) {
    /**
     * @generated from enum value: PORTAL_ORDER_CART_ITEM_GOODS_TYPE_UNSPECIFIED = 0;
     */
    PortalOrderCartItemGoodsType[PortalOrderCartItemGoodsType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PORTAL_ORDER_CART_ITEM_GOODS_TYPE_DIGITAL = 1;
     */
    PortalOrderCartItemGoodsType[PortalOrderCartItemGoodsType["DIGITAL"] = 1] = "DIGITAL";
    /**
     * @generated from enum value: PORTAL_ORDER_CART_ITEM_GOODS_TYPE_SELF_SHIPPING = 2;
     */
    PortalOrderCartItemGoodsType[PortalOrderCartItemGoodsType["SELF_SHIPPING"] = 2] = "SELF_SHIPPING";
})(PortalOrderCartItemGoodsType = exports.PortalOrderCartItemGoodsType || (exports.PortalOrderCartItemGoodsType = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalOrderCartItemGoodsType)
protobuf_1.proto3.util.setEnumType(PortalOrderCartItemGoodsType, "spwn.order.v1.PortalOrderCartItemGoodsType", [
    { no: 0, name: "PORTAL_ORDER_CART_ITEM_GOODS_TYPE_UNSPECIFIED" },
    { no: 1, name: "PORTAL_ORDER_CART_ITEM_GOODS_TYPE_DIGITAL" },
    { no: 2, name: "PORTAL_ORDER_CART_ITEM_GOODS_TYPE_SELF_SHIPPING" },
]);
/**
 * ユーザーが注文し、支払いを行う単位
 * 買い合せできる商品の組み合わせを制限しないために、商品の種類ごとの PortalOrder を定義せず共通のメッセージを使用する。
 *
 * @generated from message spwn.order.v1.PortalOrder
 */
class PortalOrder extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * 注文番号
         *
         * @generated from field: string order_number = 2;
         */
        this.orderNumber = "";
        /**
         * 支払い状況
         *
         * @generated from field: spwn.order.v1.PortalOrderFinancialStatus financial_status = 3;
         */
        this.financialStatus = PortalOrderFinancialStatus.UNSPECIFIED;
        /**
         * 注文に含まれる商品
         *
         * @generated from field: repeated spwn.order.v1.PortalOrderLineItem line_items = 4;
         */
        this.lineItems = [];
        /**
         * 商品の合計金額
         *
         * @generated from field: int32 total_item_amount = 5;
         */
        this.totalItemAmount = 0;
        /**
         * 配送料
         *
         * @generated from field: int32 total_shipping_fee_amount = 6;
         */
        this.totalShippingFeeAmount = 0;
        /**
         * 合計金額
         *
         * @generated from field: int32 total_payment_amount = 7;
         */
        this.totalPaymentAmount = 0;
        /**
         * 注文日時
         *
         * @generated from field: int64 ordered_at = 8;
         */
        this.orderedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrder, a, b);
    }
}
exports.PortalOrder = PortalOrder;
PortalOrder.runtime = protobuf_1.proto3;
PortalOrder.typeName = "spwn.order.v1.PortalOrder";
PortalOrder.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "financial_status", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalOrderFinancialStatus) },
    { no: 4, name: "line_items", kind: "message", T: PortalOrderLineItem, repeated: true },
    { no: 5, name: "total_item_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_shipping_fee_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "total_payment_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "ordered_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "paid_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "canceled_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 11, name: "shipping", kind: "message", T: PortalOrderShipping, opt: true },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderShipping
 */
class PortalOrderShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.order.v1.PortalOrderShipping.shipping
         */
        this.shipping = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderShipping, a, b);
    }
}
exports.PortalOrderShipping = PortalOrderShipping;
PortalOrderShipping.runtime = protobuf_1.proto3;
PortalOrderShipping.typeName = "spwn.order.v1.PortalOrderShipping";
PortalOrderShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "self", kind: "message", T: PortalOrderShippingSelf, oneof: "shipping" },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderShippingSelf
 */
class PortalOrderShippingSelf extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 配送状況
         *
         * @generated from field: spwn.order.v1.PortalOrderFulfillmentStatus status = 1;
         */
        this.status = PortalOrderFulfillmentStatus.UNSPECIFIED;
        /**
         * 配送先郵便番号
         *
         * @generated from field: string shipping_postal_code = 3;
         */
        this.shippingPostalCode = "";
        /**
         * 配送先住所
         *
         * @generated from field: string shipping_address = 4;
         */
        this.shippingAddress = "";
        /**
         * 配送先名
         *
         * @generated from field: string shipping_name = 5;
         */
        this.shippingName = "";
        /**
         * 配送先電話番号
         *
         * @generated from field: string shipping_phone_number = 6;
         */
        this.shippingPhoneNumber = "";
        /**
         * 配送先メールアドレス
         *
         * @generated from field: string shipping_email = 7;
         */
        this.shippingEmail = "";
        /**
         * 配送業者
         *
         * @generated from field: string shipping_carrier_name = 8;
         */
        this.shippingCarrierName = "";
        /**
         * 追跡番号
         *
         * @generated from field: string tracking_number = 9;
         */
        this.trackingNumber = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderShippingSelf().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderShippingSelf().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderShippingSelf().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderShippingSelf, a, b);
    }
}
exports.PortalOrderShippingSelf = PortalOrderShippingSelf;
PortalOrderShippingSelf.runtime = protobuf_1.proto3;
PortalOrderShippingSelf.typeName = "spwn.order.v1.PortalOrderShippingSelf";
PortalOrderShippingSelf.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalOrderFulfillmentStatus) },
    { no: 2, name: "shipped_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "shipping_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "shipping_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "shipping_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "shipping_phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "shipping_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "shipping_carrier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "tracking_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderLineItem
 */
class PortalOrderLineItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.order.v1.PortalOrderLineItem.line_item
         */
        this.lineItem = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderLineItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderLineItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderLineItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderLineItem, a, b);
    }
}
exports.PortalOrderLineItem = PortalOrderLineItem;
PortalOrderLineItem.runtime = protobuf_1.proto3;
PortalOrderLineItem.typeName = "spwn.order.v1.PortalOrderLineItem";
PortalOrderLineItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 3, name: "digital_goods", kind: "message", T: PortalOrderLineItemGoodsDigital, oneof: "line_item" },
    { no: 4, name: "self_shipping_goods", kind: "message", T: PortalOrderLineItemGoodsSelfShipping, oneof: "line_item" },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderLineItemPlan
 */
class PortalOrderLineItemPlan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string plan_id = 2;
         */
        this.planId = "";
        /**
         * @generated from field: string plan_name = 3;
         */
        this.planName = "";
        /**
         * @generated from field: string plan_thumbnail = 4;
         */
        this.planThumbnail = "";
        /**
         * @generated from field: int32 plan_price = 5;
         */
        this.planPrice = 0;
        /**
         * @generated from field: int32 quantity = 6;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderLineItemPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderLineItemPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderLineItemPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderLineItemPlan, a, b);
    }
}
exports.PortalOrderLineItemPlan = PortalOrderLineItemPlan;
PortalOrderLineItemPlan.runtime = protobuf_1.proto3;
PortalOrderLineItemPlan.typeName = "spwn.order.v1.PortalOrderLineItemPlan";
PortalOrderLineItemPlan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "plan_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "plan_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderLineItemBackNumber
 */
class PortalOrderLineItemBackNumber extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string plan_id = 2;
         */
        this.planId = "";
        /**
         * @generated from field: string plan_name = 3;
         */
        this.planName = "";
        /**
         * @generated from field: string plan_thumbnail = 4;
         */
        this.planThumbnail = "";
        /**
         * @generated from field: int32 plan_price = 5;
         */
        this.planPrice = 0;
        /**
         * @generated from field: int32 back_number_year = 6;
         */
        this.backNumberYear = 0;
        /**
         * @generated from field: int32 back_number_month = 7;
         */
        this.backNumberMonth = 0;
        /**
         * @generated from field: int32 quantity = 8;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderLineItemBackNumber().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderLineItemBackNumber().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderLineItemBackNumber().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderLineItemBackNumber, a, b);
    }
}
exports.PortalOrderLineItemBackNumber = PortalOrderLineItemBackNumber;
PortalOrderLineItemBackNumber.runtime = protobuf_1.proto3;
PortalOrderLineItemBackNumber.typeName = "spwn.order.v1.PortalOrderLineItemBackNumber";
PortalOrderLineItemBackNumber.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "plan_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "plan_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "back_number_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "back_number_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderLineItemGoodsDigital
 */
class PortalOrderLineItemGoodsDigital extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string goods_id = 2;
         */
        this.goodsId = "";
        /**
         * @generated from field: string goods_name = 3;
         */
        this.goodsName = "";
        /**
         * @generated from field: string goods_variant_id = 4;
         */
        this.goodsVariantId = "";
        /**
         * @generated from field: string goods_variant_name = 5;
         */
        this.goodsVariantName = "";
        /**
         * @generated from field: string goods_thumbnail = 6;
         */
        this.goodsThumbnail = "";
        /**
         * @generated from field: int32 goods_price = 7;
         */
        this.goodsPrice = 0;
        /**
         * @generated from field: int32 quantity = 8;
         */
        this.quantity = 0;
        /**
         * @generated from field: repeated spwn.order.v1.PortalOrderLineItemGoodsDigital.File files = 10;
         */
        this.files = [];
        /**
         * ブランドID
         *
         * @generated from field: string brand_id = 11;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_slug = 12;
         */
        this.brandSlug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderLineItemGoodsDigital().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderLineItemGoodsDigital().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderLineItemGoodsDigital().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderLineItemGoodsDigital, a, b);
    }
}
exports.PortalOrderLineItemGoodsDigital = PortalOrderLineItemGoodsDigital;
PortalOrderLineItemGoodsDigital.runtime = protobuf_1.proto3;
PortalOrderLineItemGoodsDigital.typeName = "spwn.order.v1.PortalOrderLineItemGoodsDigital";
PortalOrderLineItemGoodsDigital.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goods_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "goods_variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "goods_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "goods_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "files", kind: "message", T: PortalOrderLineItemGoodsDigital_File, repeated: true },
    { no: 11, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * ダウンロード可能なファイル
 *
 * @generated from message spwn.order.v1.PortalOrderLineItemGoodsDigital.File
 */
class PortalOrderLineItemGoodsDigital_File extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        /**
         * @generated from field: string file_download_url = 2;
         */
        this.fileDownloadUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderLineItemGoodsDigital_File().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderLineItemGoodsDigital_File().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderLineItemGoodsDigital_File().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderLineItemGoodsDigital_File, a, b);
    }
}
exports.PortalOrderLineItemGoodsDigital_File = PortalOrderLineItemGoodsDigital_File;
PortalOrderLineItemGoodsDigital_File.runtime = protobuf_1.proto3;
PortalOrderLineItemGoodsDigital_File.typeName = "spwn.order.v1.PortalOrderLineItemGoodsDigital.File";
PortalOrderLineItemGoodsDigital_File.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderLineItemGoodsSelfShipping
 */
class PortalOrderLineItemGoodsSelfShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_line_item_id = 1;
         */
        this.orderLineItemId = "";
        /**
         * @generated from field: string goods_id = 2;
         */
        this.goodsId = "";
        /**
         * @generated from field: string goods_name = 3;
         */
        this.goodsName = "";
        /**
         * @generated from field: string goods_variant_id = 4;
         */
        this.goodsVariantId = "";
        /**
         * @generated from field: string goods_variant_name = 5;
         */
        this.goodsVariantName = "";
        /**
         * @generated from field: string goods_thumbnail = 6;
         */
        this.goodsThumbnail = "";
        /**
         * @generated from field: int32 goods_price = 7;
         */
        this.goodsPrice = 0;
        /**
         * @generated from field: int32 quantity = 8;
         */
        this.quantity = 0;
        /**
         * ブランドID
         *
         * @generated from field: string brand_id = 9;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_slug = 10;
         */
        this.brandSlug = "";
        /**
         * @generated from field: string delivery_time_text = 11;
         */
        this.deliveryTimeText = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderLineItemGoodsSelfShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderLineItemGoodsSelfShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderLineItemGoodsSelfShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderLineItemGoodsSelfShipping, a, b);
    }
}
exports.PortalOrderLineItemGoodsSelfShipping = PortalOrderLineItemGoodsSelfShipping;
PortalOrderLineItemGoodsSelfShipping.runtime = protobuf_1.proto3;
PortalOrderLineItemGoodsSelfShipping.typeName = "spwn.order.v1.PortalOrderLineItemGoodsSelfShipping";
PortalOrderLineItemGoodsSelfShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_line_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goods_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "goods_variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "goods_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "goods_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "delivery_time_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderGoodsImage
 */
class PortalOrderGoodsImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string src = 1;
         */
        this.src = "";
        /**
         * @generated from field: int32 position = 2;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderGoodsImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderGoodsImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderGoodsImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderGoodsImage, a, b);
    }
}
exports.PortalOrderGoodsImage = PortalOrderGoodsImage;
PortalOrderGoodsImage.runtime = protobuf_1.proto3;
PortalOrderGoodsImage.typeName = "spwn.order.v1.PortalOrderGoodsImage";
PortalOrderGoodsImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderCartItemGoods
 */
class PortalOrderCartItemGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズのID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * バリエーションのID
         *
         * @generated from field: string variant_id = 2;
         */
        this.variantId = "";
        /**
         * グッズの名前
         *
         * @generated from field: string goods_name = 3;
         */
        this.goodsName = "";
        /**
         * バリエーションの名前
         *
         * @generated from field: string variant_name = 4;
         */
        this.variantName = "";
        /**
         * グッズの画像
         *
         * @generated from field: repeated spwn.order.v1.PortalOrderGoodsImage goods_images = 5;
         */
        this.goodsImages = [];
        /**
         * カートに入れたグッズの数量
         *
         * @generated from field: int32 quantity = 6;
         */
        this.quantity = 0;
        /**
         * グッズの在庫数
         *
         * @generated from field: int32 inventory_quantity = 7;
         */
        this.inventoryQuantity = 0;
        /**
         * グッズ単体の価格
         *
         * @generated from field: int32 price = 9;
         */
        this.price = 0;
        /**
         * ブランドID
         *
         * @generated from field: string brand_id = 10;
         */
        this.brandId = "";
        /**
         * ブランドslug
         *
         * @generated from field: string brand_slug = 11;
         */
        this.brandSlug = "";
        /**
         * グッズの種別
         *
         * @generated from field: spwn.order.v1.PortalOrderCartItemGoodsType goods_type = 12;
         */
        this.goodsType = PortalOrderCartItemGoodsType.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItemGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItemGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItemGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItemGoods, a, b);
    }
}
exports.PortalOrderCartItemGoods = PortalOrderCartItemGoods;
PortalOrderCartItemGoods.runtime = protobuf_1.proto3;
PortalOrderCartItemGoods.typeName = "spwn.order.v1.PortalOrderCartItemGoods";
PortalOrderCartItemGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goods_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "goods_images", kind: "message", T: PortalOrderGoodsImage, repeated: true },
    { no: 6, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "variant_image", kind: "message", T: PortalOrderCartItemGoods_VariantImage },
    { no: 9, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "goods_type", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalOrderCartItemGoodsType) },
    { no: 13, name: "shipping_setting", kind: "message", T: ShippingSetting },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderCartItemGoods.VariantImage
 */
class PortalOrderCartItemGoods_VariantImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string src = 1;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItemGoods_VariantImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItemGoods_VariantImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItemGoods_VariantImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItemGoods_VariantImage, a, b);
    }
}
exports.PortalOrderCartItemGoods_VariantImage = PortalOrderCartItemGoods_VariantImage;
PortalOrderCartItemGoods_VariantImage.runtime = protobuf_1.proto3;
PortalOrderCartItemGoods_VariantImage.typeName = "spwn.order.v1.PortalOrderCartItemGoods.VariantImage";
PortalOrderCartItemGoods_VariantImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.ShippingSetting
 */
class ShippingSetting extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 配送料
         *
         * @generated from field: int32 shipping_fee = 1;
         */
        this.shippingFee = 0;
        /**
         * 発送日
         *
         * @generated from field: int64 shipping_at = 2;
         */
        this.shippingAt = protobuf_1.protoInt64.zero;
        /**
         * 発送までの最低日数
         *
         * @generated from field: int32 minimum_shipping_days = 3;
         */
        this.minimumShippingDays = 0;
        /**
         * 発送までの最大日数
         *
         * @generated from field: int32 maximum_shipping_days = 4;
         */
        this.maximumShippingDays = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ShippingSetting().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShippingSetting().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShippingSetting().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ShippingSetting, a, b);
    }
}
exports.ShippingSetting = ShippingSetting;
ShippingSetting.runtime = protobuf_1.proto3;
ShippingSetting.typeName = "spwn.order.v1.ShippingSetting";
ShippingSetting.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "shipping_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "minimum_shipping_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "maximum_shipping_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderCart
 */
class PortalOrderCart extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string cart_id = 1;
         */
        this.cartId = "";
        /**
         * @generated from field: repeated spwn.order.v1.PortalOrderCartItem items = 2;
         */
        this.items = [];
        /**
         * @generated from field: bool is_shipping_required = 3;
         */
        this.isShippingRequired = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCart().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCart().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCart().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCart, a, b);
    }
}
exports.PortalOrderCart = PortalOrderCart;
PortalOrderCart.runtime = protobuf_1.proto3;
PortalOrderCart.typeName = "spwn.order.v1.PortalOrderCart";
PortalOrderCart.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "cart_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "items", kind: "message", T: PortalOrderCartItem, repeated: true },
    { no: 3, name: "is_shipping_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderCartItem
 */
class PortalOrderCartItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.order.v1.PortalOrderCartItem.item
         */
        this.item = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItem, a, b);
    }
}
exports.PortalOrderCartItem = PortalOrderCartItem;
PortalOrderCartItem.runtime = protobuf_1.proto3;
PortalOrderCartItem.typeName = "spwn.order.v1.PortalOrderCartItem";
PortalOrderCartItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: PortalOrderCartItemGoods, oneof: "item" },
]);
/**
 * カートごとの通知一覧
 *
 * @generated from message spwn.order.v1.PortalOrderCartNotifications
 */
class PortalOrderCartNotifications extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * カートID
         *
         * @generated from field: string cart_id = 1;
         */
        this.cartId = "";
        /**
         * ブランドID
         *
         * @generated from field: string brand_id = 2;
         */
        this.brandId = "";
        /**
         * ブランドslug
         *
         * @generated from field: string brand_slug = 3;
         */
        this.brandSlug = "";
        /**
         * カート内の通知一覧
         *
         * @generated from field: repeated spwn.order.v1.PortalOrderCartNotification notifications = 4;
         */
        this.notifications = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartNotifications().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartNotifications().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartNotifications().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartNotifications, a, b);
    }
}
exports.PortalOrderCartNotifications = PortalOrderCartNotifications;
PortalOrderCartNotifications.runtime = protobuf_1.proto3;
PortalOrderCartNotifications.typeName = "spwn.order.v1.PortalOrderCartNotifications";
PortalOrderCartNotifications.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "cart_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "notifications", kind: "message", T: PortalOrderCartNotification, repeated: true },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderCartNotification
 */
class PortalOrderCartNotification extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.order.v1.PortalOrderCartNotification.item
         */
        this.item = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartNotification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartNotification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartNotification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartNotification, a, b);
    }
}
exports.PortalOrderCartNotification = PortalOrderCartNotification;
PortalOrderCartNotification.runtime = protobuf_1.proto3;
PortalOrderCartNotification.typeName = "spwn.order.v1.PortalOrderCartNotification";
PortalOrderCartNotification.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "out_of_stock", kind: "message", T: PortalOrderCartItemNotificationGoodsOutOfStock, oneof: "item" },
    { no: 2, name: "short_of_stock", kind: "message", T: PortalOrderCartItemNotificationGoodsShortOfStock, oneof: "item" },
    { no: 3, name: "out_of_sales", kind: "message", T: PortalOrderCartItemNotificationGoodsOutOfSales, oneof: "item" },
    { no: 4, name: "price_changed", kind: "message", T: PortalOrderCartItemNotificationGoodsPriceChanged, oneof: "item" },
    { no: 5, name: "unaccessible", kind: "message", T: PortalOrderCartItemNotificationGoodsUnaccessible, oneof: "item" },
]);
/**
 * グッズが在庫切れの場合の通知内容
 *
 * @generated from message spwn.order.v1.PortalOrderCartItemNotificationGoodsOutOfStock
 */
class PortalOrderCartItemNotificationGoodsOutOfStock extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItemNotificationGoodsOutOfStock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItemNotificationGoodsOutOfStock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItemNotificationGoodsOutOfStock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItemNotificationGoodsOutOfStock, a, b);
    }
}
exports.PortalOrderCartItemNotificationGoodsOutOfStock = PortalOrderCartItemNotificationGoodsOutOfStock;
PortalOrderCartItemNotificationGoodsOutOfStock.runtime = protobuf_1.proto3;
PortalOrderCartItemNotificationGoodsOutOfStock.typeName = "spwn.order.v1.PortalOrderCartItemNotificationGoodsOutOfStock";
PortalOrderCartItemNotificationGoodsOutOfStock.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: PortalOrderCartItemNotificationGoods },
]);
/**
 * グッズが在庫不足の場合の通知内容
 *
 * @generated from message spwn.order.v1.PortalOrderCartItemNotificationGoodsShortOfStock
 */
class PortalOrderCartItemNotificationGoodsShortOfStock extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 在庫に残っている数
         *
         * @generated from field: int32 remaining_stock_number = 2;
         */
        this.remainingStockNumber = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItemNotificationGoodsShortOfStock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItemNotificationGoodsShortOfStock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItemNotificationGoodsShortOfStock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItemNotificationGoodsShortOfStock, a, b);
    }
}
exports.PortalOrderCartItemNotificationGoodsShortOfStock = PortalOrderCartItemNotificationGoodsShortOfStock;
PortalOrderCartItemNotificationGoodsShortOfStock.runtime = protobuf_1.proto3;
PortalOrderCartItemNotificationGoodsShortOfStock.typeName = "spwn.order.v1.PortalOrderCartItemNotificationGoodsShortOfStock";
PortalOrderCartItemNotificationGoodsShortOfStock.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: PortalOrderCartItemNotificationGoods },
    { no: 2, name: "remaining_stock_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * グッズが販売期間外の場合の通知内容
 *
 * @generated from message spwn.order.v1.PortalOrderCartItemNotificationGoodsOutOfSales
 */
class PortalOrderCartItemNotificationGoodsOutOfSales extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItemNotificationGoodsOutOfSales().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItemNotificationGoodsOutOfSales().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItemNotificationGoodsOutOfSales().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItemNotificationGoodsOutOfSales, a, b);
    }
}
exports.PortalOrderCartItemNotificationGoodsOutOfSales = PortalOrderCartItemNotificationGoodsOutOfSales;
PortalOrderCartItemNotificationGoodsOutOfSales.runtime = protobuf_1.proto3;
PortalOrderCartItemNotificationGoodsOutOfSales.typeName = "spwn.order.v1.PortalOrderCartItemNotificationGoodsOutOfSales";
PortalOrderCartItemNotificationGoodsOutOfSales.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: PortalOrderCartItemNotificationGoods },
]);
/**
 * グッズの価格が変更された場合の通知内容
 *
 * @generated from message spwn.order.v1.PortalOrderCartItemNotificationGoodsPriceChanged
 */
class PortalOrderCartItemNotificationGoodsPriceChanged extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 元の価格
         *
         * @generated from field: int32 price_snapshot = 2;
         */
        this.priceSnapshot = 0;
        /**
         * 現在の価格 // goods.priceと同じ値になると思うので不要?
         *
         * @generated from field: int32 current_price = 3;
         */
        this.currentPrice = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItemNotificationGoodsPriceChanged().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItemNotificationGoodsPriceChanged().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItemNotificationGoodsPriceChanged().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItemNotificationGoodsPriceChanged, a, b);
    }
}
exports.PortalOrderCartItemNotificationGoodsPriceChanged = PortalOrderCartItemNotificationGoodsPriceChanged;
PortalOrderCartItemNotificationGoodsPriceChanged.runtime = protobuf_1.proto3;
PortalOrderCartItemNotificationGoodsPriceChanged.typeName = "spwn.order.v1.PortalOrderCartItemNotificationGoodsPriceChanged";
PortalOrderCartItemNotificationGoodsPriceChanged.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods", kind: "message", T: PortalOrderCartItemNotificationGoods },
    { no: 2, name: "price_snapshot", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "current_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * グッズがアクセス不可の場合の通知内容
 *
 * @generated from message spwn.order.v1.PortalOrderCartItemNotificationGoodsUnaccessible
 */
class PortalOrderCartItemNotificationGoodsUnaccessible extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 元のグッズ名
         *
         * @generated from field: string goods_name_snapshot = 1;
         */
        this.goodsNameSnapshot = "";
        /**
         * 元のバリエーション名
         *
         * @generated from field: string goods_variant_name_snapshot = 2;
         */
        this.goodsVariantNameSnapshot = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItemNotificationGoodsUnaccessible().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItemNotificationGoodsUnaccessible().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItemNotificationGoodsUnaccessible().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItemNotificationGoodsUnaccessible, a, b);
    }
}
exports.PortalOrderCartItemNotificationGoodsUnaccessible = PortalOrderCartItemNotificationGoodsUnaccessible;
PortalOrderCartItemNotificationGoodsUnaccessible.runtime = protobuf_1.proto3;
PortalOrderCartItemNotificationGoodsUnaccessible.typeName = "spwn.order.v1.PortalOrderCartItemNotificationGoodsUnaccessible";
PortalOrderCartItemNotificationGoodsUnaccessible.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_name_snapshot", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_variant_name_snapshot", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderCartItemNotificationGoods
 */
class PortalOrderCartItemNotificationGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * グッズID
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * グッズ名
         *
         * @generated from field: string goods_name = 2;
         */
        this.goodsName = "";
        /**
         * バリエーションID
         *
         * @generated from field: string variant_id = 3;
         */
        this.variantId = "";
        /**
         * バリエーション名
         *
         * @generated from field: string variant_name = 4;
         */
        this.variantName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderCartItemNotificationGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderCartItemNotificationGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderCartItemNotificationGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderCartItemNotificationGoods, a, b);
    }
}
exports.PortalOrderCartItemNotificationGoods = PortalOrderCartItemNotificationGoods;
PortalOrderCartItemNotificationGoods.runtime = protobuf_1.proto3;
PortalOrderCartItemNotificationGoods.typeName = "spwn.order.v1.PortalOrderCartItemNotificationGoods";
PortalOrderCartItemNotificationGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=portal_common_pb.js.map